import { useLayoutEffect, useRef, useState } from 'react';

interface Props {
  text: string;
  maxLines: number;
}

const ReadMoreText = ({ text, maxLines }: Props) => {
  const [expanded, setExpanded] = useState(false);
  const [displayText, setDisplayText] = useState(text);
  const containerRef = useRef(null);
  const textRef = useRef(null);

  useLayoutEffect(() => {
    if (!containerRef.current || !textRef.current) return;

    const container = containerRef.current;
    const textElement = textRef.current;
    const ellipsis = '...';
    let newText = text;
    // Set the full text first.
    (textElement as HTMLElement).innerText = text;

    // If the full text already fits, there's nothing to do.
    if ((container as HTMLElement).scrollHeight <= (container as HTMLElement).clientHeight) {
      setDisplayText(text);
      return;
    }

    while ((container as HTMLElement).scrollHeight > (container as HTMLElement).clientHeight && newText.length > 0) {
      newText = newText.slice(0, -1);
      (textElement as HTMLElement).innerText = newText.trimEnd() + ellipsis;
    }

    setDisplayText(newText.trimEnd() + ellipsis);
  }, [text, maxLines]);

  return (
    <div
      ref={containerRef}
      style={{
        display: '-webkit-box',
        WebkitBoxOrient: 'vertical',
        WebkitLineClamp: expanded ? 'unset' : maxLines,
        overflow: 'hidden',
        position: 'relative',
        lineHeight: '1.5em',
        maxHeight: expanded ? 'none' : `${maxLines * 25}px`
      }}
    >
      <span ref={textRef} style={{ display: 'inline', fontSize: '14px', color: '#78909C' }}>
        {expanded ? text : displayText}
      </span>
      {displayText !== text && !expanded && (
        <button
          onClick={() => setExpanded(true)}
          style={{
            color: '#0078FF',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            display: 'inline',
            padding: 0,
            marginLeft: '0.5em',
            fontSize: '14px'
          }}
        >
          Read more
        </button>
      )}
    </div>
  );
};

export default ReadMoreText;
